const translationsEs = {
  es: {
    login: {
      form: {
        welcome: 'Bienvenido de nuevo',
        to: 'Análisis de datos de seguimiento',
        vendor: 'Aviation Technologies. We create future',
        userName: 'User name',
        authorize: 'Log in',
        password: 'Password',
        userUnexist: 'User unexist'
      }
    },
    tracksTree: {
      apply: 'Aplicar',
      toolbar: {
        trackList: 'lista de tracks'
      },
      menuDropdown: {
        fileMenu: 'Menú',
        expand: 'Expand',
        collapse: 'Collapse',
        delete: 'Borrar',
        export: 'Exportación',
        process: 'Editar',
        removeSelection: 'Cancelar asignación',
        exportCoordinates: 'Export coordinates',
        events: 'Events',
        params: 'Parameters',
        templates: 'Templates'
      },
      trackTitle: {
        organization: 'Org.',
        vehicle: 'Vehicle',
        name: 'Track',
        startedAt: 'Track start time',
        origin: 'Origin',
        destination: 'Destination',
      },
      trackControls: {
        confirm: 'Confirm track deleting',
      },
      folderControls: {
        confirm: 'Confirm folder deleting',
      },
    },
    tracksTable: {
      toolbar: {
        trackList: 'lista de tracks'
      },
      menuDropdown: {
        fileMenu: 'Menú',
        delete: 'Borrar',
        export: 'Exportación',
        process: 'Editar',
        removeSelection: 'Cancelar asignación',
        exportCoordinates: 'Export coordinates',
        events: 'Events',
        params: 'Parameters',
        templates: 'Templates'
      },
      table: {
        vehicle: 'Vehicle',
        name: 'Track',
        organization: 'Organization',
        startedAt: 'Track start time',
        origin: 'Origin',
        destination: 'Destination',
      },
    },
    uploadingPreview: {
      toolbar: {
        preview: 'Preview'
      }
    },
    settings: {
      list: {
        options: 'Conservar',
        save: 'Save',
        printTableStep: 'Paso mesa de impresión',
        mainChartColor: 'Color principal fondo de la carta',
        lineWidth: 'Chart líneas de ancho',
        trackShowAction: 'Track show action',
        pointsMaxCount: 'Max points count on chart'
      }
    },
    trackStatistics: {
      toolbar: {
        aggregatedStatistics: 'Aggregated statistics',
      },
      trackFilter: {
        trackInfoFilter: 'Filter by track info',
        apply: 'Aplicar',
        recorderType: 'Tipo de registro',
        vehicle:'Número de aeronaves',
        name:'Vuelo',
        departureFromDate:'From date',
        departureToDate:'To date',
        origin: 'Aeropuerto de salida',
        destination: 'Aterrizaje de aeropuertos',
      },
      paramsFilter: {
        apply: 'Aplicar',
        putTrackFilter: 'Put track filter',
        noMonitoredParamsOnSpecifyedFilter: 'No monitored params on specifyed filter',
        monitoredParameters: 'Monitored parameters',
      },
      values: {
        results: 'Report',
        setParamsForReportGenerating: 'Set params for report generating',
        noDataToGenerateReport: 'No data to generate report'
      },
      valuesRow: {
        title: 'Param',
        count: 'Count',
        min: 'Min',
        avg: 'Avg',
        sum: 'Sum',
        max: 'Max',
      }
    },
    trackTemplates: {
      item: {
        events: 'Events',
        default: 'Default',
        last: 'Last viewed'
      }
    },
    trackEvents: {
      formPrint: {
        grayscale: 'Grayscale'
      },
      trackComment: {
        operatorAdmitted: 'Operator admitted',
        vehicleAllowed: 'Vehicle allowed',
        generalAdmission: 'General admission',
        save: 'Save'
      },
      title: {
        recorderName: 'Recorder',
        vehicle: 'Vehicle',
        name: 'Track',
        startedAt: 'The time and date of the track',
        origin: 'Origin',
        destination: 'Destination',
        centringto: 'Center of Gravity Takeoff',
        centringlndg: 'Center of Gravity Landing',
        weightto: 'Weight Takeoff',
        weightlndg: 'Weight Landing',
        tto: 'Temperature Takeoff',
        operator: 'Operator',
        route: 'Route',
        centring: 'Center of Gravity',
      },
      list: {
        processingNotPerformed: 'Processing not performed',
        noEvents: 'Events not found'
      },
      collapse: {
        eventCodeMask000: "Technological posts",
        eventCodeMask001: "Piloting equipment control",
        eventCodeMask002: "Health control",
        eventCodeMask003: "Information messages",
      },
      contentHeader: {
        start: 'Start',
        end: 'End',
        duration: 'Duration',
        code: 'Code',
        eventName: 'Name',
        algorithm: 'Algorithm',
        aditionalInfo: 'Aditional info',
        reliability: 'Reliability',
        comment: 'Comment',
      }
    },
    calibration: {
      toolbar: {
        title: 'Calibration'
      },
      table: {
        recorder: 'Recorder',
        name: 'Name',
        dateCreation: 'Creation Date',
        dateLastEdit: 'Last Edit'
      },
      create: 'Create',
      creationForm: 'Calibration Creation Form',
      for: 'for',
      paramName: 'Name',
      paramCode: 'Code',
      paramChannels: 'Channels',
      valueAdd: 'Add',
      save: 'Save',
      update: 'Update',
      list: 'To List',
      unexist: 'No calibrations',
      controls: 'Controls',
      edit: 'Edit',
      delete: 'Delete',
      inputName: 'Please input name to save',
    },
    calibrationForm: {
      toolbar: {
        title: 'Calibration for recorder %{recorderName}'
      },
      spreadsheetTitle: {
        code: 'Code',
        physics: 'Physics'
      },
      spreadsheet: {
        addButton: 'Add row'
      },
      param: {
        code: 'Code',
        name: 'Name (dim)',
        channels: 'Channels',
        minValue: 'Min value',
        maxValue: 'Max value',
        deviationFromStandardView: 'Deviation from standard view'
      }
    },
    trackUploader: {
      upload: 'Upload',
      filesList: 'Files list',
    },
    usersTable: {
      toolbar: {
        list: 'Users list',
      },
      table: {
        login: 'Login',
        name: 'Name',
        email: 'Email',
        phone: 'Phone',
        lang: 'Language',
        role: 'Role',
        company: 'Organization',
        logo: 'Logo',
        create: 'Create',
        edit: 'Edit',
        delete: 'Delete',
        list: 'List',
        save: 'Save',
        confimUserDeleting: 'Confirm user deleting'
      }
    },
    userForm: {
      toolbar: {
        create: 'Create new user',
        edit: 'Edit user'
      },
      form: {
        login: 'Login',
        name: 'Name',
        email: 'Email',
        phone: 'Phone',
        pass: 'Password',
        repeatPass: 'Repeat password',
        company: 'Organization',
        role: 'Role',
        logo: 'Logo',
        avaliableRecorders: 'Set avaliable Recorders',
        chooseFile: 'Choose logo',
        notAllNecessarySent: 'Not all necessary params filled (marked by *)',
        alreadyExist: 'User with same login already exist',
        creationError: 'User creation error'
      },
      roleRadio: {
        admin: 'Admin',
        moderator: 'Moderator',
        user: 'User'
      }
    },
    userActivity: {
      toolbar: {
        list: 'User activity',
      },
      table: {
        action: 'Action',
        status: 'Status',
        message: 'Response message',
        date: 'Date'
      }
    },
    supervision: {
      verticalToolbar: {
        connectionParams: 'Connection params',
        recorderType: 'Recorder type',
        start: 'Run',
        stop: 'Stop',
        save: 'Save',
      },
      dataSource: {
        kvViaUdp: 'KV via UDP',
        file: 'File',
        fileViaUdp: 'File via UDP',
        connectionType: 'Connection type',
        sourceIps: 'Sources IP addresses',
        addSource: 'Add source',
        fakeData: 'Test data',
        chooseFile: 'Choose file',
        enterIpToConnect: 'Please enter IP to connect'
      },
      chooseParamsButtons: {
        chooseSource: 'Choose params source',
        template: 'Template',
        manual: 'Manual',
        chooseParamsToShow: 'Choose params to show',
        containerParams: 'Show list',
        chooseParamsToShowInContainer: 'Choose params to show',
        apply: 'Apply'
      },
      physics: {
        header: 'Physical parameter values',
        chooseParams: 'Please, choose params to show'
      },
      binary: {
        header: 'Active binary params'
      },
      events: {
        header: 'Stream data analysis'
      },
      ungrouped: 'Ungrouped'
    },
    chart: {
      threeDim: {
        model: {
          follow: 'Follow',
          freeCamera: 'Free camera',
        }
      }
    },
    topMenu: {
      brand: 'Vehiclesos',
      supervision: 'Supervision',
      fileImport: 'Import',
      upload: 'Upload',
      trackImporterDropdown: {
        fileImport: 'Import',
        chooseFile: 'Choose file',
      },
      trackUploaderDropdown: {
        trackUploading: 'Track uploading',
        chooseFile: 'Choose file',
        preview: 'Preview',
        on: 'On',
        off: 'Off',
      }
    },
    recorderSelector: {
      placeholder: 'Select recorder type'
    },
    recorderTemplateSelector: {
      placeholder: 'Select template',
      item: {
        default: 'Default',
        last: 'Last',
        events: 'Events',
      }
    },
    cycloParams: {
      colorPicker: {
        cancel: 'Cancel',
        save: 'Save'
      }
    },
    mainMenu: {
      tracks: 'Tracks',
      recorders: 'Recorders',
      calibration: 'Calibration',
      users: 'Users',
      results: 'Results',
      search: 'Search',
    },
    trackViewOptionsSwitch: {
      events: 'Events',
      params: 'Parameters',
      templates: 'Templates'
    },
    trackListViewSwitch : {
      treeView: 'Madera',
      tableView: 'Mesa',
    },
    trackTemplateEdit: {
      toolbar: {
        templates: 'Templates'
      },
      saveForm: {
        templateName: 'Template Name'
      }
    },
    table: {
      previous: 'Previous',
      next: 'Next',
      loading: 'Loading...',
      noRowsFound: 'No rows found',
      page: 'Page',
      of: 'of',
      rows: 'rows',
    }
  }
}

export default translationsEs;
